import { Box, List, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FeatureListItem from './FeatureListItem';

const FeaturesContainer = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('desktop')]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          gap: theme.spacing(3),
        },
        my: theme.spacing(4),
      }}
    >
      <List disablePadding sx={{ minWidth: theme.spacing(40) }}>
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:apiIntegrations')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:mediaStreaming')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:musicLabels')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:physicalLocations')}
        />
      </List>
      <List disablePadding sx={{ minWidth: theme.spacing(40) }}>
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:largeEnterprise')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:advertisingCampaigns')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:subLicensing')}
        />
        <FeatureListItem
          primary={t('distribution:licenseBlock:features:partnerships')}
        />
      </List>
    </Box>
  );
};

export default FeaturesContainer;
